import React from "react";
import { PackageSearch } from "lucide-react";
import type { BackendOrder } from "./types";
import OrderCard from "./OrderCard";

interface OrdersListProps {
  orders: BackendOrder[];
  filteredOrders: BackendOrder[];
  loading: boolean;
}

const OrdersList: React.FC<OrdersListProps> = ({
  orders,
  filteredOrders,
  loading,
}) => {
  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center py-24 bg-neutral-900">
        <div className="animate-spin rounded-full h-12 w-12 border-4 border-primary border-t-transparent mb-4"></div>
        <span className="text-neutral-400 font-medium">Loading orders...</span>
      </div>
    );
  }

  if (filteredOrders.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-24 px-4 bg-neutral-900 text-center">
        <div className="relative inline-block mb-6">
          <div className="absolute inset-0 bg-primary/20 rounded-full blur-xl opacity-30"></div>
          <PackageSearch
            className="relative w-20 h-20 text-neutral-600"
            strokeWidth={1.5}
          />
        </div>
        <h3 className="text-xl font-bold text-white mb-2">No orders found</h3>
        <p className="text-neutral-400 max-w-sm mx-auto leading-relaxed">
          {orders.length === 0
            ? "You haven't placed any orders yet. Start shopping to fill this list!"
            : `No orders match your search. Try adjusting your filters.`}
        </p>
      </div>
    );
  }

  return (
    <div className="divide-y divide-neutral-800 bg-neutral-900">
      {filteredOrders.map((order) => (
        <OrderCard key={order.id} order={order} orders={orders} />
      ))}
    </div>
  );
};

export default OrdersList;
